import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app.tsx';

const rootElement = document.querySelector('#root')!;
const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
